<template>
  <div>
    <ClientHeader title="Detalle Cliente" />
    <hr>
    <template v-if="clientLoaded && productsLoaded">
      <ClientForm :products="products" :client="client" @onUpdate="onUpdate"/>
    </template>
    <span v-else>
      Loading..
    </span>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import ClientHeader from '../ClientHeader'
import ClientForm from '../ClientForm'

export default {
  name: 'ClientDetail',
  components: {
    ClientHeader,
    ClientForm
  },
  props: {
    clientId: {
      type: String,
      required: true
    }
  },
  computed: {
    isDataLoaded () {
      return this.products.length > 0 && Object.keys(this.client).length > 0
    },
    productsFormatted () {
      return this.products.map(item => {
        return {
          value: item.id,
          text: item.name
        }
      })
    }
  },
  data () {
    return {
      products: [],
      client: {
        productPrices: [
          {
            id: '',
            price: 0
          }
        ],
        deliverySchedule: []
      },
      productsLoaded: false,
      clientLoaded: false
    }
  },
  created () {
    this.loadProducts()
    this.loadClientData()
  },
  methods: {
    ...mapMutations([
      'toggleClientLoading'
    ]),
    ...mapActions([
      'getClientDetail',
      'updateClientDetail',
      'setAlertData',
      'getProducts'
    ]),
    loadClientData () {
      this.getClientDetail(this.clientId)
        .then((res) => {
          this.clientLoaded = true
          this.client = { ...res.data(), id: res.id }
        })
        .catch((err) => {
          console.log('[getProductDetail]')
          console.log(err)
        })
    },
    loadProducts () {
      this.getProducts()
        .then((res) => {
          this.productsLoaded = true
          res.forEach(doc => {
            this.products.push({ id: doc.id, ...doc.data() })
          })
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    onUpdate (data) {
      this.toggleClientLoading(true)
      data.updatedAt = new Date().getTime()
      this.updateClientDetail(data)
        .then(() => {
          window.scrollTo(0, 0)
          this.toggleClientLoading(false)
          this.setAlertData({
            visible: true,
            msg: 'Cliente Actualizado ;)',
            type: 'success'
          })
        })
        .catch((err) => {
          this.toggleClientLoading(false)
          this.setAlertData({
            visible: true,
            msg: err.toString(),
            type: 'danger'
          })
          console.log('[updateClientDetail]')
          console.log(err)
        })
    }
  }
}
</script>
